import { render, staticRenderFns } from "./ReClientLentaNest.vue?vue&type=template&id=07052438&scoped=true"
import script from "./ReClientLentaNest.vue?vue&type=script&lang=js"
export * from "./ReClientLentaNest.vue?vue&type=script&lang=js"
import style0 from "./ReClientLentaNest.vue?vue&type=style&index=0&id=07052438&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07052438",
  null
  
)

export default component.exports